import(/* webpackMode: "eager" */ "/var/www/gligle-app-front-next/src/app/assets/styles/Document.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/gligle-app-front-next/src/containers/MainContainer/MainContainer.tsx");
